module.exports = __webpack_public_path__ + "static/media/blink-logo.a4893b57.png";